import "./../styles.scss";

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  LoadingOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { Radio, Select } from "antd";
import { notification, Spin } from "antd";
import { Avatar, Dropdown, Tooltip } from "antd";
import { Field, Form, Formik } from "formik";
import { get, includes } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import { ROLE } from "../../../constants/phase";
import {
  addAkimaiStorageValidation,
  addAWSStorageValidation,
  addAzureStorageValidation,
  addGCPStorageValidation,
  addMultipleAkimaiStorageValidation,
  addMultipleAWSStorageValidation,
  addMultipleAzureStorageValidation,
  addMultipleGCPStorageValidation,
  addMultipleStorageValidation,
  addStorageValidation,
} from "../../../utils/validations";
import EditStorage from "./EditStorage";
import UpdateStorageAccess from "./updateStorageAccess";

const AddStorage = (props) => {
  const { Option } = Select;
  const {
    createStorage,
    loder,
    setLoder,
    setStorageDetail,
    storageDetail,
    deleteStorage,
    clientSetting,
    storageValidation,
    validateValues,
    setValidateValues,
    addDisable,
    setAddDisable,
    handleValidate,
    allowAcl,
    setAllowAcl,
    setIsExistingStorage,
    storage,
    setStorage,
    validateLoder,
    setValidateLoader,
    user,
    getStorageList,
    setUserSearch,
    selectedUser,
    setSelectedUser,
    getAssignedStorageOrganization,
    getOrganizationStorage,
    id,
    updateStorageMultipleFolderPath,
  } = props;
  const { entityId, currentRole } = useOutletContext();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [bucketType, setBucketType] = useState("");
  const [env, setEnv] = useState("production");
  const [file, setFile] = useState("");
  const [editStorage, setEditStorage] = useState([]);
  const [storageId, setStorageId] = useState("");
  // const [e2eUpload, setE2EUpload] = useState(false);
  const [editmodalOpen, setEditmodalOpen] = useState(false);
  const [userId] = useState(localStorage.getItem("__uid"));
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [storeLoder, setStoreLoder] = useState(false);
  const [validationSchemas, setValidationSchemas] = useState(addStorageValidation);
  const [formValues, setFormValues] = useState([{}]);
  const [element, setElement] = useState("");
  // const [defaultStorage, setDefaultStorage] = useState(false);
  const [options, setoptions] = useState([]);
  const [count, setCount] = useState(0);
  const [disableOption, setDisableOption] = useState(false);
  const [organizationSearch, setOrganizationSearch] = useState("");
  const [openStorageAccessModal, setOpenStorageAccessModal] = useState(false);
  const initialState = {
    name: "aws",
    bucket_type: "",
    secret_key: "",
    access_key: "",
    e2eupload: false,
    region: "",
    bucket_name: "",
    ns_hostname: "",
    ns_keyname: "",
    ns_key: "",
    ns_cpcode: "",
    file: "",
    connection_string: "",
    folder_path: "",
    multiple_folder_path: "",
    cdn_suffix: "",
    acl_allow_public: "",
    gcp_bucket_name: "",
    storage_name: "",
    default_Storage: false,
  };
  function hasEmptyKey(array, key) {
    return array.filter((obj) => obj.hasOwnProperty(key) && obj[key] !== "");
  }

  const handleSubmit = async ({
    bucket_name,
    storage_name,
    secret_key,
    access_key,
    region,
    ns_hostname,
    ns_keyname,
    ns_key,
    ns_cpcode,
    connection_string,
    folder_path,
    multiple_folder_path,
    cdn_suffix,
    gcp_bucket_name,
  }) => {
    const filtered_array = hasEmptyKey(formValues, "multiple_folder_path");

    if (addDisable && storage == "aws") {
      setAddDisable(true);
    } else {
      setLoder(true);
      const payload = {
        storage: {
          credentials: {
            secret_key,
            access_key,
            isE2EUpload: false,
            region,
            bucket_name,
            ns_hostname,
            ns_keyname,
            ns_key,
            ns_cpcode,
            file: file,
            connection_string,
            folder_path:
              clientSetting?.permissions?.multipleStoragePath == true
                ? formValues[0]?.multiple_folder_path
                : folder_path,
            multiple_folder_path: filtered_array,
            cdn_suffix,
            acl_allow_public: allowAcl,
            gcp_bucket_name,
          },
          defaultStorage: false,
          storage_type: bucketType,
          storage_name,
          name: storage,
          isValidate: !addDisable,
          lastValidateDate: new Date(),
          env: env,
          type: [
            "videos",
            "keymoments",
            "highlights",
            "ads_video",
            "sports_keymoments",
            "customAds_video",
            "transcript",
            "h2v_maker",
            "entertainment",
          ],
        },
        // userIds: user.role == "admin" ? [user._id] : selectedUser,
        userIds: currentRole === ROLE.ADMIN ? [user._id] : selectedUser,
      };
      let data = await createStorage(payload);
      // setDefaultStorage(false);
      setSelectedUser([]);
      setFormValues([{}]);
      if (data?.value?.success) {
        setIsOpen(false);
        getStorageDetails();
        notification["success"]({ message: data?.value.message });
        setLoder(false);
      } else {
        setLoder(false);
        setIsOpen(false);
        notification["error"]({ message: data?.value.message });
      }
      setAddDisable(true);
      setUserSearch("");
    }
  };
  const updateNotification = (msg) => {
    notification.open({
      message: msg,
    });
  };
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    setAddDisable(true);
    setUserSearch("");
    setSelectedUser([]);
    setCount(count + 1);
  };
  const delOpen = (uId) => {
    setStorageId(uId);
    setDeleteModalOpen(true);
  };

  const editOpen = (user) => {
    setEditmodalOpen(true);
    setEditStorage(user);
  };

  useEffect(() => {
    getStorageDetails();
  }, [userId]);

  const getStorageDetails = async () => {
    try {
      let storageData;
      // For other roles, fetch data with respect to organizationId
      const { value } = await getOrganizationStorage({
        entityId: id,
        type: "sports_keymoments",
        access: false,
      });
      storageData = value.storages || [];

      setStorageDetail(storageData);
    } catch (error) {
      console.error("Error fetching storage details:", error);
      // Handle error if needed
    }
  };

  const deleteStorageModel = async () => {
    setStoreLoder(true);
    const { value } = await deleteStorage({
      _id: storageId,
    });
    if (value.success) {
      setStoreLoder(false);
      delclose();
      getStorageDetails();
      notification["success"]({ message: value.message });
    } else {
      setStoreLoder(false);
      delclose();
      notification["error"]({ message: value.message });
    }
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };
  const handleStorage = (value, setFieldValue) => {
    setFieldValue("name", value);
    setStorage(value);
    switch (value) {
      case "aws":
        setValidationSchemas(
          clientSetting?.permissions?.multipleStoragePath == true
            ? addMultipleAWSStorageValidation
            : addAWSStorageValidation,
        );
        break;
      case "akamai":
        setValidationSchemas(
          clientSetting?.permissions?.multipleStoragePath == true
            ? addMultipleAkimaiStorageValidation
            : addAkimaiStorageValidation,
        );
        break;
      case "azure":
        setValidationSchemas(
          clientSetting?.permissions?.multipleStoragePath == true
            ? addMultipleAzureStorageValidation
            : addAzureStorageValidation,
        );
        break;
      case "gcp":
        setValidationSchemas(
          clientSetting?.permissions?.multipleStoragePath == true
            ? addMultipleGCPStorageValidation
            : addGCPStorageValidation,
        );
        break;
      default:
        setValidationSchemas(
          clientSetting?.permissions?.multipleStoragePath == true ? addMultipleStorageValidation : addStorageValidation,
        );
    }
  };
  const handleBucketType = (value, setFieldValue) => {
    setFieldValue("bucket_type", value);
    setBucketType(value);
  };

  //to fetch multiple folder path values
  const handleClick = () => {
    setFormValues([...formValues, { multiple_folder_path: "" }]);
  };

  //to set multiple folder path values
  const handleChange = (i, e, setFieldValue) => {
    let newFormValues = [...formValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFormValues(newFormValues);
    setFieldValue("multiple_folder_path", formValues);
    setFieldValue("folder_path", e.target.value);
  };

  const actions = {
    view_storage_for_admin: true,
    edit_storage: true,
    // delete_storage: true,
    update_storage_access: true,
  };

  const updateStorageAccess = (storage) => {
    setOpenStorageAccessModal(true);
  };

  const handleStorageTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      if (profileFeature.hasOwnProperty(key) && profileFeature?.[key]) {
        switch (key) {
          case "edit_storage":
            user._id == element.createdBy &&
              currentRole !== ROLE.SUPER_ADMIN &&
              menuItems.push({
                label: (
                  <a
                    rel="noopener noreferrer"
                    onClick={() => {
                      setDisableOption(false);
                      editOpen(element);
                    }}
                  >
                    <ProfileOutlined />
                    <span>Edit Storage</span>
                  </a>
                ),
                key: "0",
              });
            break;
          case "update_storage_access":
            currentRole !== ROLE.SUPER_ADMIN &&
              menuItems.push({
                label: (
                  <a rel="noopener noreferrer" onClick={() => updateStorageAccess(element)}>
                    <ProfileOutlined />
                    <span>Update Storage Access</span>
                  </a>
                ),
                key: "0",
              });
            break;

          case "delete_storage":
            (user._id == element.createdBy || currentRole === ROLE.SUPER_ADMIN) &&
              menuItems.push({
                label: (
                  <a
                    rel="noopener noreferrer"
                    onClick={() => {
                      delOpen(get(element, "_id", ""));
                    }}
                  >
                    <DeleteIcon />
                    <span>Delete Storage</span>
                  </a>
                ),
                key: "1",
              });
            break;
          case "view_storage_for_admin":
            (user._id !== element.createdBy || currentRole === ROLE.SUPER_ADMIN) &&
              menuItems.push({
                label: (
                  <a
                    rel="noopener noreferrer"
                    onClick={() => {
                      setDisableOption(true);
                      editOpen(element);
                    }}
                  >
                    <EyeOutlined />
                    <span>View Storage</span>
                  </a>
                ),
                key: "3",
              });
            break;
        }
      }
    }
  };
  //validation function
  const handleStoreValidate = async (values, resetForm) => {
    handleValidate(values, resetForm);
    setValidateValues(values);
    setIsExistingStorage(false);
  };
  //check if any change after validating in storage
  const handleValidatedata = (dirty) => {
    if (addDisable != dirty) {
      if (dirty) {
        setAddDisable(true);
      } else {
        setAddDisable(false);
      }
    }
  };
  return (
    <>
      {editmodalOpen ? (
        <EditStorage
          setEditmodalOpen={setEditmodalOpen}
          editmodalOpen={editmodalOpen}
          editStorage={editStorage}
          {...props}
          handleValidate={handleValidate}
          getStorageDetails={getStorageDetails}
          setIsExistingStorage={setIsExistingStorage}
          setStorage={setStorage}
          setValidateLoader={setValidateLoader}
          validateLoder={validateLoder}
          storageValidation={storageValidation}
          options={options}
          disableOption={disableOption}
          fromCentarliseStorage={false}
          getAssignedStorageOrganization={getAssignedStorageOrganization}
          setOrganizationSearch={setOrganizationSearch}
          organizationSearch={organizationSearch}
        />
      ) : null}
      <DeleteModal
        setDeleteModalOpen={setDeleteModalOpen}
        modalIsOpen={delmodalOpen}
        loder={storeLoder}
        deleteComanModel={deleteStorageModel}
        header="Delete"
        content="Are you certain about deleting? This action will result in the removal of storage from all assigned users."
      />
      {openStorageAccessModal ? (
        <UpdateStorageAccess
          openStorageAccessModal={openStorageAccessModal}
          setOpenStorageAccessModal={setOpenStorageAccessModal}
          updateStorageMultipleFolderPath={updateStorageMultipleFolderPath}
          getStorageDetails={getStorageDetails}
          id={id}
          storage={element}
          clientSetting={clientSetting}
        />
      ) : null}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Storage Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-lg modal-dialog-centered filter-modal"
      >
        <Formik initialValues={initialState} validationSchema={validationSchemas} onSubmit={handleSubmit}>
          {({ dirty, values, errors, touched, setFieldValue, resetForm }) => (
            <div className="modal-content">
              {dirty && handleValidatedata(dirty)}
              <Form>
                <div className="react-modal-header">
                  <h5 className="react-modal-title">Add Storage</h5>
                  <button type="button" onClick={closeModal} className="btn btn__default">
                    <CloseModal />
                  </button>
                </div>
                <div className="react-modal-body">
                  <div className="add-form-contianer">
                    {/* <AccessControl code="select_admin_user" page="configuration">
                      <div className="form-group custom-search-select">
                        <label className="form-label">
                          Admins & Users<span className="required"></span>
                        </label>
                        <Select
                          className="custom-ant-select large-select-container"
                          mode="multiple"
                          value={selectedUser}
                          onChange={handleChangeuser}
                          filterOption={false}
                          onSearch={(e) => {
                            setUserSearch(e);
                          }}
                        >
                          {options.map((option) => (
                            <Option key={option.value} value={option.value}>
                              <Checkbox className="me-2" checked={_.includes(selectedUser, option.value)} />
                              {option.label}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </AccessControl> */}
                    <div className="three-column-row">
                      <div class="form-group">
                        <label className="form-label">Cloud Type</label>
                        <div class="input-block">
                          <Field
                            //className={touched.name && errors.name ? "name" : ""}
                            name="name"
                            onChange={(value) => handleStorage(value, setFieldValue)}
                            component={Select}
                            dropdownStyle={{ zIndex: 99999999 }}
                            placeholder="Select Storage"
                            className="custom-ant-select"
                            value={storage}
                          >
                            <Option value="aws">AWS S3</Option>
                            <Option value="akamai">AKAMAI</Option>
                            <Option value="gcp">GCP</Option>
                            <Option value="azure">Azure</Option>
                          </Field>
                          {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                        </div>
                      </div>
                      <div class="form-group">
                        <label className="form-label">Bucket Type</label>
                        <Field
                          // className={touched.bucketType && errors.bucketType ? "error" : ""}
                          name="bucket_type"
                          onChange={(value) => handleBucketType(value, setFieldValue)}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          placeholder="Select Bucket Type"
                          className="custom-ant-select"
                        >
                          <Radio value={"production"}>Production</Radio>
                          <Radio value={"story"}>Story Storage</Radio>
                        </Field>
                        {touched.bucket_type && errors.bucket_type && (
                          <div className="invalid-feedback">{errors.bucket_type}</div>
                        )}
                      </div>
                      <div class="form-group">
                        <label className="form-label">Environment</label>
                        <div className="input-block fill-radio-custom">
                          <Radio.Group defaultValue="production" onChange={(e) => setEnv(e.target.value)}>
                            <Radio.Button value="production">Production</Radio.Button>
                            <Radio.Button value="qa">QA</Radio.Button>
                          </Radio.Group>
                        </div>
                      </div>
                    </div>
                    {storage === "aws" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Bucket Name</label>
                            <Field
                              //className={touched.bucketname && errors.bucketname ? "error" : ""}
                              name="bucket_name"
                              type="text"
                              className="form-control"
                            />
                            {touched.bucket_name && errors.bucket_name && (
                              <div className="invalid-feedback">{errors.bucket_name}</div>
                            )}
                          </div>
                          <div class="form-group">
                            <label className="form-label">Secret Key</label>
                            <Field
                              //className={touched.secretkey && errors.secretkey ? "error" : ""}
                              name="secret_key"
                              type="text"
                              className="form-control"
                            />
                            {touched.secret_key && errors.secret_key && (
                              <div className="invalid-feedback">{errors.secret_key}</div>
                            )}
                          </div>
                        </div>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Access Key</label>
                            <Field
                              //className={touched.accesskey && errors.accesskey ? "error" : ""}
                              name="access_key"
                              type="text"
                              className="form-control"
                            />
                            {touched.access_key && errors.access_key && (
                              <div className="invalid-feedback">{errors.access_key}</div>
                            )}
                          </div>
                          <div class="form-group">
                            <label className="form-label">Bucket Region</label>
                            <Field
                              //className={touched.bucketregion && errors.bucketregion ? "error" : ""}
                              name="region"
                              type="text"
                              className="form-control"
                            />
                            {touched.region && errors.region && <div className="invalid-feedback">{errors.region}</div>}
                          </div>
                          {/* <div class="form-group">
                            <label className="form-label">E2E Upload</label>
                            <div className="input-block fill-radio-custom">
                              <Radio.Group defaultValue={false} onChange={(e) => setE2EUpload(e.target.value)}>
                                <Radio.Button value={true}>Yes</Radio.Button>
                                <Radio.Button value={false}>No</Radio.Button>
                              </Radio.Group>
                              {touched.e2eupload && errors.e2eupload && (
                                <div className="invalid-feedback">{errors.e2eupload}</div>
                              )}
                            </div>
                          </div> */}
                        </div>{" "}
                      </>
                    ) : null}
                    {storage == "akamai" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">NS HOSTNAME</label>
                            <Field
                              //className={touched.nshostname && errors.nshostname ? "error" : ""}
                              name="ns_hostname"
                              type="text"
                              className="form-control"
                            />
                            {touched.ns_hostname && errors.ns_hostname && (
                              <div className="invalid-feedback">{errors.ns_hostname}</div>
                            )}
                          </div>

                          <div class="form-group">
                            <label className="form-label">NS KEYNAME</label>
                            <Field
                              //className={touched.nskeyname && errors.nskeyname ? "error" : ""}
                              name="ns_keyname"
                              type="text"
                              className="form-control"
                            />
                            {touched.ns_keyname && errors.ns_keyname && (
                              <div className="invalid-feedback">{errors.ns_keyname}</div>
                            )}
                          </div>
                        </div>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">NS KEY</label>
                            <Field
                              //className={touched.nskey && errors.nskey ? "error" : ""}
                              name="ns_key"
                              type="text"
                              className="form-control"
                            />
                            {touched.ns_key && errors.ns_key && <div className="invalid-feedback">{errors.ns_key}</div>}
                          </div>
                          <div class="form-group">
                            <label className="form-label">NS CPCODE</label>
                            <Field
                              //className={touched.nscpcode && errors.nscpcode ? "error" : ""}
                              name="ns_cpcode"
                              type="text"
                              className="form-control"
                            />
                            {touched.ns_cpcode && errors.ns_cpcode && (
                              <div className="invalid-feedback">{errors.ns_cpcode}</div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : null}
                    {storage == "gcp" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Bucket Name</label>
                            <Field
                              //className={touched.bucketname && errors.bucketname ? "error" : ""}
                              name="gcp_bucket_name"
                              type="text"
                              className="form-control"
                            />
                            {touched.gcp_bucket_name && errors.gcp_bucket_name && (
                              <div className="invalid-feedback">{errors.gcp_bucket_name}</div>
                            )}
                          </div>
                          <div class="form-group">
                            <label className="form-label">&nbsp;</label>
                            <div className="upload-btn-container custom-upload-btn-input">
                              <input
                                onChange={(e) => setFile(e.target.value)}
                                type="file"
                                className="btn custom-upload-btn"
                              />
                              <span className="upload-point">Upload File</span>
                            </div>
                            {touched.file && errors.file && <div className="invalid-feedback">{errors.file}</div>}
                          </div>
                        </div>
                      </>
                    ) : null}
                    {storage == "azure" ? (
                      <>
                        <div className="three-column-row">
                          <div class="form-group">
                            <label className="form-label">Bucket Name</label>
                            <Field
                              //className={touched.bucketname && errors.bucketname ? "error" : ""}
                              name="bucket_name"
                              type="text"
                              className="form-control"
                            />
                            {touched.bucket_name && errors.bucket_name && (
                              <div className="invalid-feedback">{errors.bucket_name}</div>
                            )}
                          </div>
                          <div class="form-group">
                            <label className="form-label">Connection String</label>
                            <Field
                              // className={touched.connectionstring && errors.connectionstring ? "error" : ""}
                              name="connection_string"
                              type="text"
                              className="form-control"
                            />
                            {touched.connection_string && errors.connection_string && (
                              <div className="invalid-feedback">{errors.connection_string}</div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : null}

                    {clientSetting?.permissions?.multipleStoragePath == true ? (
                      <>
                        {formValues.map((element, index) => {
                          return (
                            <>
                              <div class="form-group">
                                <label className="form-label">Bucket Folder Path {index + 1}</label>
                                <Field
                                  // className={touched.bucketpath && errors.bucketpath ? "error" : ""}
                                  name="multiple_folder_path"
                                  type="text"
                                  value={element.multiple_folder_path}
                                  className="form-control"
                                  onChange={(e) => handleChange(index, e, setFieldValue)}
                                />
                                {touched.multiple_folder_path && errors.multiple_folder_path && (
                                  <div className="invalid-feedback">{errors.multiple_folder_path}</div>
                                )}
                              </div>
                              {index === formValues.length - 1 && (
                                <button
                                  type="button"
                                  disabled={includes([null, "", undefined, "null"], element.multiple_folder_path)}
                                  className="btn btn-primary btn-small"
                                  onClick={() => handleClick()}
                                >
                                  Add More Bucket Folder Path
                                </button>
                              )}
                            </>
                          );
                        })}{" "}
                      </>
                    ) : (
                      <>
                        <div class="form-group">
                          <label className="form-label">Bucket Folder Path</label>
                          <Field
                            // className={touched.bucketpath && errors.bucketpath ? "error" : ""}
                            name="folder_path"
                            type="text"
                            className="form-control"
                          />
                          {touched.folder_path && errors.folder_path && (
                            <div className="invalid-feedback">{errors.folder_path}</div>
                          )}
                        </div>{" "}
                      </>
                    )}

                    <div className="three-column-row">
                      <div class="form-group">
                        <label className="form-label">Storage Name</label>
                        <Field
                          //className={touched.name && errors.name ? "error" : ""}
                          name="storage_name"
                          type="text"
                          className="form-control"
                        />
                        {touched.storage_name && errors.storage_name && (
                          <div className="invalid-feedback">{errors.storage_name}</div>
                        )}
                      </div>
                      <div class="form-group">
                        <label className="form-label">CDN Suffix</label>
                        <Field
                          //className={touched.cdnsuffix && errors.cdnsuffix ? "error" : ""}
                          name="cdn_suffix"
                          type="text"
                          className="form-control"
                        />
                        {touched.cdn_suffix && errors.cdn_suffix && (
                          <div className="invalid-feedback">{errors.cdn_suffix}</div>
                        )}
                      </div>
                    </div>
                    <div className="three-column-row">
                      <div class="form-group">
                        <label className="form-label">Allow ACL</label>
                        <div className="input-block fill-radio-custom">
                          <Radio.Group defaultValue="yes" onChange={(e) => setAllowAcl(e.target.value)}>
                            <Radio.Button value="yes">Yes</Radio.Button>
                            <Radio.Button value="no">No</Radio.Button>
                          </Radio.Group>
                          {touched.acl_allow_public && errors.acl_allow_public && (
                            <div className="invalid-feedback">{errors.acl_allow_public}</div>
                          )}
                        </div>
                      </div>
                      {/* <div class="form-group">
                        <label className="form-label">Default Storage</label>
                        <div className="input-block fill-radio-custom">
                          <Radio.Group
                            defaultValue={defaultStorage}
                            onChange={(e) => setDefaultStorage(e.target.value)}
                          >
                            <Radio.Button value={true}>Yes</Radio.Button>
                            <Radio.Button value={false}>No</Radio.Button>
                          </Radio.Group>
                        </div>
                      </div> */}
                      {/* <div class="form-group">
                        <label className="form-label">Region</label>
                        <div class="input-block">
                          <input type="text" placeholder="Enter Region" />
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-md-end text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      {storage == "aws" && (
                        <button
                          type="button"
                          disabled={validateLoder}
                          className="btn btn-primary"
                          onClick={() => {
                            handleStoreValidate(values, resetForm);
                          }}
                        >
                          {validateLoder ? "Validating..." : "Validate"}
                        </button>
                      )}
                      <button
                        type="submit"
                        disabled={addDisable && storage !== "akamai" && storage !== "gcp" && storage !== "azure"}
                        className="btn btn-primary"
                      >
                        Add
                        {loder && (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </Modal>
      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Storage</h4>
            <p>Add storage for further mapping</p>
          </div>
          <div className="right-btn-block">
            <div class="button-container">
              {clientSetting?.permissions?.addStorageButton == true && currentRole !== ROLE.SUPER_ADMIN ? (
                <button class="btn btn-primary" onClick={openModal}>
                  Add Storage
                </button>
              ) : (
                <></>
                // <AccessControl code="add_storage" page="configuration">
                //   <button class="btn btn-primary" onClick={openModal}>
                //     Add Storage
                //   </button>
                // </AccessControl>
              )}
            </div>
          </div>
        </div>

        <div className="border-block mt-3">
          <div className="row">
            <h4 className="title-sm-t">Production</h4>
            <div className="col-md-12">
              <div className="table-resposive table-container user-management-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Storage Name</th>
                      <th>Storage Type</th>
                      <th>Bucket Name</th>
                      <th>Env</th>
                      <th>Status</th>
                      <th style={{ textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {storageDetail ? (
                      storageDetail.map((elem) => {
                        const validateDate = moment.utc(elem?.validateDate).local().format("DD-MM-YYYY");
                        return (
                          <>
                            {elem.storage_type == "production" ? (
                              <tr key={elem._id}>
                                <td>
                                  <div className="table-name-img">
                                    <div className="img-container">
                                      <Avatar size="large" style={{ verticalAlign: "middle" }}>
                                        {get(elem, "icon_url", "")}
                                      </Avatar>
                                    </div>
                                    <h5>
                                      {" "}
                                      {elem?.storage_name
                                        .split(" ")
                                        .map(
                                          (letter, index) =>
                                            letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase(),
                                        )
                                        .join(" ")}
                                    </h5>
                                  </div>
                                </td>
                                <td>{get(elem, "name", "")}</td>
                                <td>
                                  {elem.name === "gcp"
                                    ? get(elem, "credentials.display_bucket_name", "")
                                    : get(elem, "credentials.display_bucket_name", "")}
                                </td>
                                <td style={{ textTransform: "capitalize" }}>{get(elem, "env", "")}</td>
                                {elem?.name === "aws" || elem?.name === "gcp" ? (
                                  <td>
                                    <Tooltip
                                      title={
                                        elem.isValidate !== undefined
                                          ? "last validated on :" + validateDate
                                          : "not validated"
                                      }
                                    >
                                      {elem?.isValidate ? (
                                        <span className="key-status completed">
                                          <CheckCircleOutlined style={{ fontSize: "18px" }} />
                                        </span>
                                      ) : elem.isValidate !== undefined && !elem.isValidate ? (
                                        <span className="key-status failed">
                                          <CloseCircleOutlined style={{ fontSize: "18px" }} />
                                        </span>
                                      ) : (
                                        <span className="key-status pending">
                                          <ExclamationCircleOutlined style={{ fontSize: "18px" }} />
                                        </span>
                                      )}
                                    </Tooltip>
                                  </td>
                                ) : (
                                  <td></td>
                                )}

                                {/* {user.role == "admin" && (
                              <td>
                                <span className="status">
                                  {get(elem, "permissions", []).length > 0
                                    ? join(get(elem, "permissions", []), ", ")
                                    : "--"}
                                </span>
                              </td>
                            )} */}
                                <td>
                                  <div className="table-action-block text-center">
                                    <Dropdown
                                      onClick={() => {
                                        setElement(elem);
                                      }}
                                      className=""
                                      overlay={
                                        <AccessControl
                                          code="menuItem"
                                          page="organization-profile"
                                          handleTableAction={handleStorageTableAction}
                                        />
                                      }
                                      trigger={["click"]}
                                      overlayClassName={"tableActionBlock"}
                                      placement={"bottomRight"}
                                    >
                                      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                        <TheeDotsIcon />
                                      </a>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ) : null}
                          </>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7">
                          <div className="text-center  pt-5 pb-5">
                            <h3>Storage not found</h3>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
          <div className="row">
            <h4 className="title-sm-t mt-5">Story</h4>
            <div className="col-md-12">
              <div className="table-resposive table-container user-management-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Storage Name</th>
                      <th>Storage Type</th>
                      <th>Bucket Name</th>
                      <th>Env</th>
                      <th>Status</th>
                      <th style={{ textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {storageDetail ? (
                      storageDetail.map((elem) => {
                        const validateDate = moment.utc(elem?.validateDate).local().format("DD-MM-YYYY");
                        return (
                          <>
                            {elem.storage_type == "story" ? (
                              <tr key={elem._id}>
                                <td>
                                  <div className="table-name-img">
                                    <div className="img-container">
                                      <Avatar size="large" style={{ verticalAlign: "middle" }}>
                                        {get(elem, "icon_url", "")}
                                      </Avatar>
                                    </div>
                                    <h5>
                                      {" "}
                                      {elem?.storage_name
                                        .split(" ")
                                        .map(
                                          (letter, index) =>
                                            letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase(),
                                        )
                                        .join(" ")}
                                    </h5>
                                  </div>
                                </td>
                                <td>{get(elem, "name", "")}</td>
                                <td>{get(elem, "credentials.display_bucket_name", "")}</td>
                                {/* Update bucket name post decrypt*/}
                                <td style={{ textTransform: "uppercase" }}>{get(elem, "env", "")}</td>
                                {elem?.name === "aws" || elem?.name === "gcp" ? (
                                  <td>
                                    <Tooltip
                                      title={
                                        elem.isValidate !== undefined
                                          ? "last validated on :" + validateDate
                                          : "not validated"
                                      }
                                    >
                                      {elem?.isValidate ? (
                                        <span className="key-status completed">
                                          <CheckCircleOutlined style={{ fontSize: "18px" }} />
                                        </span>
                                      ) : elem.isValidate !== undefined && !elem.isValidate ? (
                                        <span className="key-status failed">
                                          <CloseCircleOutlined style={{ fontSize: "18px" }} />
                                        </span>
                                      ) : (
                                        <span className="key-status pending">
                                          <ExclamationCircleOutlined style={{ fontSize: "18px" }} />
                                        </span>
                                      )}
                                    </Tooltip>
                                  </td>
                                ) : (
                                  <td></td>
                                )}
                                {/* {user.role == "admin" && (
                              <td>
                                <span className="status">
                                  {get(elem, "permissions", []).length > 0
                                    ? join(get(elem, "permissions", []), ", ")
                                    : "--"}
                                </span>
                              </td>
                            )} */}
                                <td>
                                  <div className="table-action-block text-center">
                                    <Dropdown
                                      onClick={() => {
                                        setElement(elem);
                                      }}
                                      className=""
                                      overlay={
                                        <AccessControl
                                          code="menuItem"
                                          page="organization-profile"
                                          handleTableAction={handleStorageTableAction}
                                        />
                                      }
                                      trigger={["click"]}
                                      overlayClassName={"tableActionBlock"}
                                      placement={"bottomRight"}
                                    >
                                      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                        <TheeDotsIcon />
                                      </a>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ) : null}
                          </>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7">
                          <div className="text-center  pt-5 pb-5">
                            <h3>Storage not found</h3>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
          {storageDetail.some((elem) => elem.storage_type === "medialive") && (
            <div className="row">
              <h4 className="title-sm-t mt-5">Media Live</h4>
              <div className="col-md-12">
                <div className="table-resposive table-container user-management-table">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Storage Name</th>
                        <th>Storage Type</th>
                        <th>Bucket Name</th>
                        <th>Env</th>
                        <th>Status</th>
                        <th style={{ textAlign: "center" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {storageDetail ? (
                        storageDetail.map((elem) => {
                          const validateDate = moment.utc(elem?.validateDate).local().format("DD-MM-YYYY");
                          return (
                            <>
                              {elem.storage_type == "medialive" ? (
                                <tr key={elem._id}>
                                  <td>
                                    <div className="table-name-img">
                                      <div className="img-container">
                                        <Avatar size="large" style={{ verticalAlign: "middle" }}>
                                          {get(elem, "icon_url", "")}
                                        </Avatar>
                                      </div>
                                      <h5>
                                        {" "}
                                        {elem?.storage_name
                                          .split(" ")
                                          .map(
                                            (letter, index) =>
                                              letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase(),
                                          )
                                          .join(" ")}
                                      </h5>
                                    </div>
                                  </td>
                                  <td>{get(elem, "name", "")}</td>
                                  <td>{get(elem, "credentials.display_bucket_name", "")}</td>
                                  {/* Update bucket name post decrypt*/}
                                  <td style={{ textTransform: "uppercase" }}>{get(elem, "env", "")}</td>
                                  {elem?.name === "aws" || elem?.name === "gcp" ? (
                                    <td>
                                      <Tooltip
                                        title={
                                          elem.isValidate !== undefined
                                            ? "last validated on :" + validateDate
                                            : "not validated"
                                        }
                                      >
                                        {elem?.isValidate ? (
                                          <span className="key-status completed">
                                            <CheckCircleOutlined style={{ fontSize: "18px" }} />
                                          </span>
                                        ) : elem.isValidate !== undefined && !elem.isValidate ? (
                                          <span className="key-status failed">
                                            <CloseCircleOutlined style={{ fontSize: "18px" }} />
                                          </span>
                                        ) : (
                                          <span className="key-status pending">
                                            <ExclamationCircleOutlined style={{ fontSize: "18px" }} />
                                          </span>
                                        )}
                                      </Tooltip>
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                  {/* {user.role == "admin" && (
                              <td>
                                <span className="status">
                                  {get(elem, "permissions", []).length > 0
                                    ? join(get(elem, "permissions", []), ", ")
                                    : "--"}
                                </span>
                              </td>
                            )} */}
                                  <td>
                                    <div className="table-action-block text-center">
                                      <Dropdown
                                        onClick={() => {
                                          setElement(elem);
                                        }}
                                        className=""
                                        overlay={
                                          <AccessControl
                                            code="menuItem"
                                            page="organization-profile"
                                            handleTableAction={handleStorageTableAction}
                                          />
                                        }
                                        trigger={["click"]}
                                        overlayClassName={"tableActionBlock"}
                                        placement={"bottomRight"}
                                      >
                                        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                          <TheeDotsIcon />
                                        </a>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                              ) : null}
                            </>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="7">
                            <div className="text-center  pt-5 pb-5">
                              <h3>Storage not found</h3>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot></tfoot>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>

        <br />
      </div>
    </>
  );
};
export default AddStorage;
